import { styled, Box } from '@mui/material';
import { rem } from '@core-web/typography';

export const Wrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  //backgroundColor: palette.background.default,
  color: palette.primary.main,
}));

export const InnerWrapper = styled(Box)(({ theme: { palette } }) => ({
  textAlign: 'center',
}));

export const LoadingStatusWrapper = styled(Box)(({ theme: { palette } }) => ({
  marginTop: rem(8),
}));
